module.exports = __webpack_public_path__ + "fonts/5b1fbd62-45dc-4433-a7df-a2b24a146411.bc69d60.woff2";